// extracted by mini-css-extract-plugin
module.exports = {"gallery":"NewPhotoGallery_gallery__2wNxV","photo":"NewPhotoGallery_photo__3D28F"};